module.exports = __webpack_public_path__ + "img/icon-linkedin.bd759092.svg";